import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import LiveReceptionist from 'live-receptionist'
import { Loader, Tabs } from 'foundations-library/components'
import { Switch, Route, useHistory, useRouteMatch } from 'react-router-dom'
import CallHistory from './components/CallHistory'
import ScriptsEmptyState from './components/ScriptsEmptyState'

const jss = () => ({
    vendor8: {
        padding: '40px 20px 0 20px'
    },
    emptyState: {
        paddingTop: 0
    },
    tabs: {
        maxWidth: 600,
        margin: '40px auto'
    },
    content: {
        maxWidth: 1200,
        margin: '0 auto',
        '& .page-content': {
            margin: '0 auto'
        }
    }
})

const useStyles = makeStyles(jss)

/**
 *
 */
const Vendor8 = (): JSX.Element => {
    const styles = useStyles()
    const match = useRouteMatch()
    const history = useHistory()
    const basePath = useMemo(() => match.url.endsWith('/') ? match.url.slice(0, -1) : match.url, [])
    const indexMatch = useRouteMatch({ path: basePath, exact: true })
    const tabs = useMemo(() => {
        return [
            {
                text: 'Scripts',
                value: basePath,
                'data-testid': 'scripts-tab'
            },
            {
                text: 'Call history',
                value: `${basePath}/call-history`,
                'data-testid': 'call-history-tab'
            }
        ]
    }, [basePath])
    const [tab, setTab] = useState<string>(tabs[0].value)
    const [scripts, setScripts] = useState<unknown[] | null>(null)
    const [scriptsLoadFailed, setScriptsLoadFailed] = useState(false)
    const onScriptsLoaded = useCallback((items: unknown[]) => {
        setScripts(items)
        setScriptsLoadFailed(false)
    }, [])
    const onScriptsLoadError = useCallback(() => setScriptsLoadFailed(true), [])
    const loading = scripts === null && !scriptsLoadFailed
    const hasNoScripts = scripts !== null && scripts.length === 0 && !scriptsLoadFailed && Boolean(indexMatch)
    const showContent = !loading && !hasNoScripts

    useEffect(() => {
        history.push(tab)
    }, [tab])

    return <div className={`${styles.vendor8} ${hasNoScripts ? styles.emptyState : ''}`}>
        {loading && <Loader />}

        {hasNoScripts && <ScriptsEmptyState onCreate={() => history.push(`${basePath}/create/8`)} />}

        {showContent && <Tabs
            value={tab}
            onChange={(v) => setTab(v)}
            className={styles.tabs}
            color='neutral'
            items={tabs}
        />}

        <div
            hidden={!showContent}
            className={styles.content}
        >
            <Switch>
                <Route path={`${basePath}/call-history`} exact render={() => (
                    <CallHistory />
                )} />
                <Route path={basePath} render={() => (
                    <LiveReceptionist
                        serviceType='Live Answer-Connect'
                        onScriptsLoaded={onScriptsLoaded}
                        onScriptsLoadError={onScriptsLoadError}
                    />
                )} />
            </Switch>
        </div>
    </div>
}

export default Vendor8
